import { useState } from 'react';
import { useReveal } from '@/hooks/useReveal';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import Intro from '@/pages/home/components/Intro';
import HotVideos from '@/pages/home/components/HotVideos';
import Streamers from '@/pages/home/components/Streamers';
import Collections from '@/pages/home/components/Collections';
import TagCloud from '@/pages/home/components/TagCloud';
import Guide from '@/pages/home/components/Guide';
import Community from '@/pages/home/components/Community';
import Faq from '@/pages/home/components/Faq';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  const [category, setCategory] = useState('全部');
  const [keyword, setKeyword] = useState('');

  useReveal();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <HotVideos
          category={category}
          onCategoryChange={setCategory}
          keyword={keyword}
          onKeywordChange={setKeyword}
        />
        <Streamers />
        <Collections />
        <TagCloud
          onSearch={(value) => {
            setCategory('全部');
            setKeyword(value);
          }}
        />
        <Guide />
        <Community />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}